import { render, staticRenderFns } from "./InfoStep.vue?vue&type=template&id=1b3f5355"
import script from "./InfoStep.vue?vue&type=script&lang=js"
export * from "./InfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports